import React, { useEffect } from "react";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { useSpring, animated } from "react-spring";

const Contact = () => {
  const [isVisible, setVisible] = React.useState(false);
  const [animationComplete, setAnimationComplete] = React.useState(false);

  const springProps = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateX(0%)" : "translateX(100%)",
    config: { duration: 1200 },
    onRest: () => {
      setAnimationComplete(true);
    },
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const skillsSection = document.getElementById("skills-section");
    const triggerPosition = skillsSection.offsetTop - window.innerHeight / 2;
    setVisible(animationComplete || scrollPosition > triggerPosition);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [animationComplete]);
  return (
    <section
      name="contact"
      className="flex flex-col justify-center items-center min-h-screen w-full bg-gradient-to-br from-[#0F172A] to-[#183250] text-slate-50 pt-20"
    >
      <form
        method="POST"
        action="https://getform.io/f/98f73024-3bf4-44a7-97e3-bceaba2ee53b"
        className="flex flex-col gap-y-6 p-6 mx-auto w-full max-w-[1000px]"
      >
        <p
          style={springProps}
          className="mx-auto text-4xl border-b-4 border-yellow-500 sm:text-5xl w-fit"
        >
          Contact
        </p>
        <p className="py-4 text-center">Get in touch with me</p>
        <input
          type="text"
          name="name"
          className="pl-3 mx-auto w-full h-10 text-black md:w-2/3"
          placeholder="Name"
        />
        <input
          type="text"
          name="email"
          className="pl-3 mx-auto w-full h-10 text-black md:w-2/3"
          placeholder="Email"
        />
        <textarea
          name="message"
          className="pl-3 mx-auto w-full h-52 text-black md:w-2/3"
          placeholder="Message"
        ></textarea>
        <button
          type="submit"
          className="p-2 mx-auto mt-4 border-2 hover:bg-yellow-600 hover:border-yellow-600 w-fit grou"
        >
          Let's Collaborate
        </button>
      </form>
      <div className="mx-auto">
        <ul className="flex gap-x-6 mt-12">
          <li className="p-2 rounded-md bg-[#1d1d1e] cursor-pointer">
            <a href="https://github.com/jayantghadge">
              <span>
                <FaGithub className="w-6 h-6" />
              </span>
            </a>
          </li>
          <li className="p-2 rounded-md bg-[#00A6ED] cursor-pointer">
            <a href="https://www.linkedin.com/in/jayant-ghadge-700739181">
              <span>
                <FaLinkedin className="w-6 h-6" />
              </span>
            </a>
          </li>
          <li className="p-2 rounded-md bg-[#0378c7] cursor-pointer">
            <a href="https://twitter.com/JayantGhadge">
              <span>
                <FaTwitter className="w-6 h-6" />
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Contact;
